import { NgModule } from '@angular/core';
import { RouterModule, Routes, TitleStrategy } from '@angular/router';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { PageNotFoundComponent } from 'src/app/shared/components/page-not-found/page-not-found.component';
import { DashboardLayoutComponent } from 'src/app/modules/layout/layout/dashboard-layout.component';
//import { PortalResolver } from './shared/resolvers/portal-resolvers';
import { PotalAuthorizeGuard } from 'src/app/guards/portalauthorize.guard';
import { PortalLayoutComponent } from 'src/app/modules/layout/layout/portal-layout.component';
import { CaseInsensitiveMatcher } from 'src/app/app.module';
import { ForbiddenComponent } from 'src/app/shared/components/forbidden/forbidden.component';
import { ServerErrorComponent } from 'src/app/shared/components/server-error/server-error.component';
import { ConcatTitleStrategy } from 'src/app/services';
import { ResetPotalFeatureAuthorizeGuard } from './guards/portalfeatureauthorize.guard';

const routes: Routes = [
  {
    path: "",
    loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule),
  },
  {
    //path: 'Dashboard',
    matcher: CaseInsensitiveMatcher("Dashboard"),
    component: DashboardLayoutComponent,
    loadChildren: () => import('./modules/dashboard/dashboad.module').then(m => m.DashboardModule),
    canActivate: [AuthGuard, ResetPotalFeatureAuthorizeGuard]
  },
  {
    matcher: CaseInsensitiveMatcher("Account"),
    component: DashboardLayoutComponent,
    loadChildren: () => import('./modules/account/account.module').then(m => m.AccountModule),
    canActivate: [AuthGuard, ResetPotalFeatureAuthorizeGuard]
  },
  {
    matcher: CaseInsensitiveMatcher("Go"),
    children: [
      {
        path: ':Sponsor/:Portal',
        component: PortalLayoutComponent,
        loadChildren: () => import('./modules/go/go.module').then(m => m.GoModule),
        canActivate: [PotalAuthorizeGuard]
      }
    ],
    canActivate: [AuthGuard]
  },
  {
    matcher: CaseInsensitiveMatcher("Report"),
    children: [
      {
        path: ':Sponsor/:Portal',
        component: PortalLayoutComponent,
        loadChildren: () => import('./modules/report/report.module').then(m => m.ReportModule),
        canActivate: [PotalAuthorizeGuard],
      }
    ],
    canActivate: [AuthGuard]
  },
  {
    matcher: CaseInsensitiveMatcher("Admin"),
    children: [
      {
        path: ':Sponsor/:Portal',
        component: PortalLayoutComponent,
        loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule),
        canActivate: [PotalAuthorizeGuard]
      }
    ],
    canActivate: [AuthGuard]
  },
  {
    matcher: CaseInsensitiveMatcher("Error"),
    component: DashboardLayoutComponent,
    children: [
      { matcher: CaseInsensitiveMatcher("NoAccess"), component: ForbiddenComponent },
      {matcher: CaseInsensitiveMatcher("NotFound"),component: PageNotFoundComponent },
      { matcher: CaseInsensitiveMatcher("Forbidden"), component: ForbiddenComponent },
      { matcher: CaseInsensitiveMatcher("ServerError"), component: ServerErrorComponent }
    ],
    canActivate: [AuthGuard]
  },
  { path: '**', redirectTo: '/Error/NotFound' }  // otherwise redirect to home
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [{
    provide: TitleStrategy,
    useClass: ConcatTitleStrategy
  }]
})
export class AppRoutingModule { }
